import ReactPaginate from "react-paginate";
import './Pagination.css'

export default function Pagination({ pageCount, onPageChange, forcePage }) {
	return (
		<ReactPaginate
			breakLabel="..."
			nextLabel={'▶'}
			previousLabel={'◀'}
			onPageChange={(selectedItem) => onPageChange(selectedItem.selected + 1)}
			pageRangeDisplayed={3}
			marginPagesDisplayed={1}
			pageCount={pageCount}
			forcePage={forcePage - 1}
			renderOnZeroPageCount={null}
			containerClassName="pagination"
			activeClassName="pagination_active"
			disabledClassName="disabled"
		/>
	)
}
